module.exports = __webpack_public_path__ + "img/performance-2.d9a3500f.png";